import * as React from 'react'

import { SVGResponsive } from './common'

function CaretDown() {
  return (
    <SVGResponsive height={8} width={14}>
      <path
        d="M1 1L7 7L13 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGResponsive>
  )
}

export default React.memo(CaretDown)
